import { render, staticRenderFns } from "./SmallWinsSummary.vue?vue&type=template&id=2959fcb2&scoped=true"
import script from "./SmallWinsSummary.vue?vue&type=script&lang=js"
export * from "./SmallWinsSummary.vue?vue&type=script&lang=js"
import style0 from "./SmallWinsSummary.vue?vue&type=style&index=0&id=2959fcb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2959fcb2",
  null
  
)

export default component.exports